import React from 'react';

type InfoRow = [string, React.ReactNode] | null | undefined | false;

interface InfoTableProps {
  rows: InfoRow[];
}

const InfoTable: React.FC<InfoTableProps> = ({ rows }) => (
  <div style={{
    borderRadius: 'var(--r-md)',
    overflow: 'hidden',
    border: '1px solid var(--glass-border)',
    background: 'var(--glass-bg)',
    backdropFilter: 'var(--glass-blur)',
    WebkitBackdropFilter: 'var(--glass-blur)',
  }}>
    {rows.filter(Boolean).map((row, i, arr) => {
      if (!row) return null;
      const [k, v] = row;
      if (v === undefined || v === null) return null;
      return (
        <div
          key={k}
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            padding: '13px 16px',
            gap: 12,
            borderBottom: i < arr.length - 1 ? '1px solid var(--glass-border)' : 'none',
          }}
        >
          <span style={{ color: 'var(--text2)', fontSize: 13, width: 120, flexShrink: 0 }}>{k}</span>
          <span style={{ color: 'var(--text0)', fontSize: 14, fontWeight: 500, flex: 1 }}>{v}</span>
        </div>
      );
    })}
  </div>
);

export default InfoTable;
